module.exports = "/images/deleted_user.png?6e22d43d722c8116ad55cd746a4d3e8f";